import { useSelector } from "react-redux";

import { ROUTES } from "@/constants/routes_sidebar/routes-constant";
import { Roles } from "@/interfaces/interfaces";
import { isAdminDomain } from "@/lib/utils";
import { RootState } from "@/redux/store";

export type RouteKey = keyof typeof ROUTES;
export type FeatureConfig = Partial<Record<RouteKey, boolean>> | "*";

const useGetEnvironmentFeature = (): FeatureConfig => {
  const userData = useSelector((state: RootState) => state.user?.userData);

  switch (process.env.NODE_ENV) {
    case "production":
      return userData?.role === Roles.SUPER_ADMIN
        ? "*"
        : {
            ROOT: !!isAdminDomain,
            PROJECT_REGISTER: true,
            ESTIMATES: true,
            TASK_CLAIMS: true,
            PROJECTS: true,
            WORKFORCE: true,
            ADMIN: true,
            MANAGER: true,
            EMPLOYEE: false,
            SUB_CONTRACTOR: false,
            SETTINGS: false,
            CUSTOMERS: true,
            CUSTOMER: true,
            CONTRACT_INVOICE: true,
            DOCKET_INVOICE: false,
            XERO_INVOICE: true,
            ACTIVITY: true,
            ITEMS: true,
          };
    default:
      return "*";
  }
};

export default useGetEnvironmentFeature;
